// extracted by mini-css-extract-plugin
export default {"buttonTabsWrapper":"aW7ww","bankBanner":"MFK9Q"};